import React from 'react';
import { formatDate } from '../utils/formatters';
import { icons } from '../assets/icons';

interface GroupCardProps {
  group: {
    id: string;
    name: string;
    member_count: number;
    updated_at: string;
  };
  user: {
    primary_group_id: string | null;
  } | null;
  isUpdating: boolean;
  onSetPrimaryGroup: (e: React.MouseEvent, groupId: string) => void;
  onNavigate: (groupId: string) => void;
}

const GroupCard = ({ group, user, isUpdating, onSetPrimaryGroup, onNavigate }: GroupCardProps) => {
  return (
    <div
      className="p-4 bg-gray-50 border border-gray-100 rounded-xl cursor-pointer select-none"
      onClick={() => onNavigate(group.id)}
    >
      <div className="flex justify-between items-center">
        <h3 
          className="text-lg font-bold grow"
        >
          {group.name}
        </h3>
        <button
          onClick={(e) => onSetPrimaryGroup(e, group.id)}
          className={`p-1 rounded-lg bg-white ${
            user?.primary_group_id === group.id 
              ? 'text-yellow-500' 
              : 'text-gray-400'
          }`}
          title={user?.primary_group_id === group.id ? "시작그룹 해제" : "시작그룹 설정"}
          disabled={isUpdating}
        >
          <img className='w-6 h-6' src={user?.primary_group_id === group.id ? icons.yellowStar : icons.grayStar} alt="star" />
        </button>
      </div>
      <div className="flex justify-between items-center mt-1">
        <div className="flex items-center text-gray-800 font-semibold">
          <img src={icons.person} alt="person" className="w-3.5 h-3.5 mr-1.5" />
          {group.member_count+"명"}
        </div>
        <p 
          className="text-gray-600"
          onClick={() => onNavigate(group.id)}
        >
          {formatDate(group.updated_at)}
        </p>
      </div>
    </div>
  );
};

export default GroupCard; 